import React, { FC } from 'react';
import MuiMenuList, { MenuListProps as MuiMenuListProps } from '@mui/material/MenuList';
import { BpDesignSystem } from '../../types';

export type MenuListProps = BpDesignSystem.PropsWithChildren<MuiMenuListProps & {}>;

export const MenuList: FC<MenuListProps> = ({ dataTest, ...props }) => <MuiMenuList data-test={dataTest} {...props} />;
